var CategoryCarouselRow        = require("app/ui/repeaters/CategoryCarouselRow"),
    ProductCategoryCarouselRow = require("app/ui/repeaters/ProductCategoryCarouselRow"),
    ProductCategoryGridRow     = require("app/ui/repeaters/ProductCategoryGridRow");

module.exports = function(category) {
    if (category.type === "product_category") {
        switch (category.children[0].type) {
            case "product_category":
                return ProductCategoryCarouselRow;
            case "product":
                return ProductCategoryGridRow;
            default:
                return null;
        }
    }
    else if (category.type === "category") {
        return CategoryCarouselRow;
    }
    else {
        return null;
    }
};
